module.exports = __webpack_public_path__ + "img/wb_b.5095a8d8.png";